export default {
  title: 'Solicitare factură',
  form: {
    is_receipt_required: {
      label: 'Solicită factură prin email',
    },
    company_name: {
      placeholder: 'Nume companie (opțional)',
    },
    first_name: {
      placeholder: 'Prenume',
    },
    last_name: {
      placeholder: 'Nume de familie',
    },
    address: {
      placeholder: 'Stradă + număr',
    },
    zip_code: {
      placeholder: 'Cod poștal',
    },
    city: {
      placeholder: 'Oraș',
    },
    tax_id: {
      placeholder: 'CUI / CIF',
    },
    email: {
      placeholder: 'Adresă de email',
    },
  },
};
